import FacebookIcon from "../../icons/facebookIcon";
import InstagramIcon from "../../icons/instagramICon";
import TwitterIcon from "../../icons/twitterIcon";
import YoutubeIcon from "../../icons/youtubeIcon";

const TeamCard = ({ member }) => {
  return (
    <div className="flex flex-col items-center my-4 space-y-4 text-center">
      <div className="relative w-60 h-60">
        <img
          src={member.img}
          alt={member.name}
          className="object-cover w-full h-full border-4 border-white rounded-full"
        />

        <svg
          className="absolute top-[-6px] left-[-6px] w-[250px] h-[250px] pointer-events-none"
          viewBox="0 0 100 100"
        >
          <circle
            cx="50"
            cy="50"
            r="49.5"
            stroke="#3B82F6"
            strokeWidth="1.5"
            fill="none"
            strokeDasharray="60 15 60 15 60 15 60 15"
            strokeLinecap="round"
            transform="rotate(11.25 50 50)"
          />
        </svg>
      </div>
      <h2 className="text-[20px] font-bold">{member.name}</h2>
      <span className="text-mainGray">{member.role}</span>
      <div className="flex items-center justify-between gap-2">
        <a href={member.facebook}>
          <FacebookIcon />
        </a>
        <hr className="h-6 border border-black" />
        <a href={member.insta}>
          <InstagramIcon />
        </a>
        <hr className="h-6 border border-black" />
        <a href={member.twitter}>
          <TwitterIcon />
        </a>
        <hr className="h-6 border border-black" />
        <a href={member.youtube}>
          <YoutubeIcon />
        </a>
      </div>
    </div>
  );
};

export default TeamCard;
